import Vue from 'vue'
import Vuex from 'vuex'
import {forgeGetToken, forgeGetFiles} from '@/helpers/api/forge'
import {getProjectRequest, isCurrentProjectRequest} from '@/helpers/projectContext'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		forgeToken: null,
		loadingToken: true,
		forgeFiles: [],
		loadingFiles: true,
		forgeSelectedFile: null,
		projectMainFile: null
	},
	mutations: {
		setForgeSelectedFile(state, file){
			state.forgeSelectedFile = file
		},
		setForgeToken(state, token){
			state.forgeToken = token
		},
		setLoadingToken(state, status){
			state.loadingToken = status
		},
		setForgeFiles(state, files){
			state.forgeFiles = files
		},
		setLoadingFiles(state, status){
			state.loadingFiles = status
		},
		setProjectMainFile(state, file){
			state.projectMainFile = file
		},
		resetForProject(state){
			state.forgeFiles = []
			state.forgeSelectedFile = null
			state.projectMainFile = null
			state.loadingFiles = false
		}
	},
	actions: {
		async fetchForgeToken(context, scopes){
			context.commit('setLoadingToken', true)
			context.commit('setForgeToken', null)

			const forgeToken = await forgeGetToken({scopes})
			if(forgeToken.code == 200 && forgeToken.access_token && forgeToken.access_token.applicationToken){
				context.commit('setForgeToken', forgeToken.access_token.applicationToken)
			}

			context.commit('setLoadingToken', false)
		},
		async fetchForgeFiles(context, data){
			const request = getProjectRequest(data.project_id)
			context.commit('setLoadingFiles', true)
			context.commit('setForgeFiles', null)

			try {
				const forgeToken = await forgeGetFiles(data)
				if(isCurrentProjectRequest(request.projectId, request.generation) && forgeToken.code == 200 && forgeToken.forge_files){
					context.commit('setForgeFiles', forgeToken.forge_files)
					context.commit('setProjectMainFile', forgeToken.project_main_file)
					if(!context.state.forgeSelectedFile && forgeToken.forge_files.length > 0){
						context.commit('setForgeSelectedFile', forgeToken.forge_files[0])
					}
				}
				return forgeToken
			} finally {
				if(isCurrentProjectRequest(request.projectId, request.generation)) context.commit('setLoadingFiles', false)
			}
		}
	},
})

export default store